export class PortalApps {
  application: string;
  displayName: string;
  baseUrl: string;
  enabled: boolean;
  routes: PortalRoutes[];
}

export class PortalRoutes {
  name: string;
  displayName: string;
  subUrl: string;
  enabled: boolean;
  icon?: string;
}

export class RouteParams {
  datasheetID: number;
  fieldID: number;
}
